import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Container,
  chakra,
  VStack,
  SimpleGrid,
  GridItem,
  Stack,
} from "@chakra-ui/react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import SearchContext from "../../SearchContext";
import LoadingSpinner from "../ui/loading-spinner";
import CarCard from "../ui/car-card";
const backendUrl = process.env.REACT_APP_BACKEND_URL;

const FeaturedVehicles = () => {
  const { searchResults } = useContext(SearchContext);
  const { t } = useTranslation();
  const [cars, setCars] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const featuredCars = [1, 2, 3, 4];

  useEffect(() => {
    const fetchCars = async () => {
      try {
        const carData = await Promise.all(
          featuredCars.map((car) =>
            axios
              .get(`${backendUrl}/api/cars/${car}`)
              .then((response) => response.data.data),
          ),
        );
        setCars(carData);
        console.log("carsData", carData);
        console.log("cars", cars);
      } catch (error) {
        console.error("Error fetching cars:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCars();
  }, []);

  if (isLoading) return <LoadingSpinner />;

  const displayCars =
    searchResults && searchResults.length > 0 ? searchResults : cars;

  return (
    <Box mt={4} p={5}>
      <Container maxW={"7xl"} py={16} as={Stack} spacing={12}>
        <Box textAlign={{ lg: "center" }}>
          <chakra.p
            mt={2}
            fontSize={{ base: "3xl", sm: "4xl" }}
            lineHeight="8"
            fontWeight="extrabold"
            letterSpacing="tight"
            color="gray.900"
          >
            {t("featuredVehicles.title")}
          </chakra.p>
          <chakra.p
            mt={4}
            maxW="2xl"
            fontSize="xl"
            mx={{ lg: "auto" }}
            color="gray.500"
          >
            {t("featuredVehicles.description")}
          </chakra.p>
        </Box>
        <VStack>
          <SimpleGrid
            columns={[1, 1, 2, 2, 3, 3]}
            rowGap={6}
            columnGap={8}
            py={10}
          >
            {displayCars.map((car) => (
              <GridItem key={car.id} colSpan={1}>
                <CarCard props={car.car} />
              </GridItem>
            ))}
          </SimpleGrid>
        </VStack>
      </Container>
    </Box>
  );
};

export default FeaturedVehicles;
